if (!customElements.get('featured-collection')) {
  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.isRendered = this.dataset.rendered === 'true';
      this.collectionHandle = this.dataset.collectionHandle;
      this.sectionId = this.dataset.sectionId;
      if (!this.isRendered) {
        setTimeout(() => {
          this.getFeaturedCollection()
        }, 1500);
      }
    }

    async getFeaturedCollection() {
      try {
        const resp = await fetch(
          `/?section_id=${this.sectionId}&render_data=true`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const responseText = await resp.text();
        const respDOM = new DOMParser().parseFromString(responseText, 'text/html');
        const featuredCollection = respDOM.querySelector('.featured-collection');

        if (!featuredCollection) return;
        this.append(featuredCollection);
        this.isRendered = true;
        this.setAttribute('data-rendered', 'true');

        debouncedUpdateSwiper();
      } catch (error) {
        console.log('Error fetching connected products:', error);
      }
    }
  }

  customElements.define('featured-collection', FeaturedCollection);
}

const debouncedUpdateSwiper = debounce(() => {
  document.dispatchEvent(new CustomEvent('update-swiper'));
}, 500);

function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}